
(() => {
  function initializeShippingPopup() {
    const popup = document.getElementById('NeviiveShippingPopup');

    if (!popup || popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const closeButton = popup.querySelector('.neviive-shipping__close');
    const overlay = popup.querySelector('.neviive-shipping__overlay');
    const continueButton = popup.querySelector('.neviive-shipping__continue');

    let pendingForm = null;
    let pendingSubmitter = null;
    let pendingUrl = null;
    let previousFocus = null;
    let allowNextSubmit = false;

    function isCheckoutUrl(url) {
      try {
        const parsed = new URL(url, window.location.origin);
        return parsed.origin === window.location.origin &&
          /^\/checkout\/?$/.test(parsed.pathname);
      } catch {
        return false;
      }
    }

    function openPopup() {
      previousFocus = document.activeElement;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('neviive-shipping-open');
      popup.querySelector('.neviive-shipping__circle')?.focus();
    }

    function closePopup() {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('neviive-shipping-open');

      if (previousFocus && previousFocus.isConnected) {
        previousFocus.focus();
      }
    }

    function interceptCheckout(event, form = null, url = null, submitter = null) {
      event.preventDefault();

      // Do not stop propagation: Shopify theme handlers may be needed.
      pendingForm = form;
      pendingSubmitter = submitter;
      pendingUrl = url;

      openPopup();
    }

    // Intercept checkout links and checkout buttons.
    document.addEventListener('click', (event) => {
      if (popup.contains(event.target)) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      const link = target.closest('a[href]');

      if (link && isCheckoutUrl(link.href)) {
        interceptCheckout(event, null, link.href);
        return;
      }

      const button = target.closest(
        'button[name="checkout"], input[name="checkout"]'
      );

      if (button && !button.disabled && button.form) {
        interceptCheckout(event, button.form, null, button);
      }
    }, true);

    // Intercept checkout submissions, including keyboard submission.
    document.addEventListener('submit', (event) => {
      if (allowNextSubmit) {
        allowNextSubmit = false;
        return;
      }

      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const submitter = event.submitter;

      const isCheckoutForm =
        form.action && isCheckoutUrl(form.action);

      const isCheckoutButton =
        submitter && submitter.name === 'checkout';

      if (isCheckoutForm || isCheckoutButton) {
        interceptCheckout(event, form, null, submitter);
      }
    }, true);

    closeButton?.addEventListener('click', closePopup);
    overlay?.addEventListener('click', closePopup);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) {
        closePopup();
      }
    });

    continueButton?.addEventListener('click', () => {
      const form = pendingForm;
      const submitter = pendingSubmitter;
      const url = pendingUrl;

      // Clear saved checkout details to prevent repeated submissions.
      pendingForm = null;
      pendingSubmitter = null;
      pendingUrl = null;

      closePopup();

      if (form && form.isConnected) {
        if (typeof form.requestSubmit === 'function') {
          allowNextSubmit = true;

          try {
            if (submitter && submitter.isConnected && submitter.form === form) {
              form.requestSubmit(submitter);
            } else {
              form.requestSubmit();
            }
          } catch (error) {
            allowNextSubmit = false;
            console.error('Could not resume checkout:', error);
          }
        } else {
          window.location.assign('/checkout');
        }
      } else if (url) {
        window.location.assign(url);
      } else {
        window.location.assign('/checkout');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeShippingPopup);
  } else {
    initializeShippingPopup();
  }
})();
